import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface YoutubePlayerProps {
  title: string;
  embedUrl: string;
}

const VideoWrapper = styled(Box)({
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%',
});

const VideoFrame = styled('iframe')({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 0,
});

const YoutubePlayer = ({ title, embedUrl }: YoutubePlayerProps) => (
  <VideoWrapper>
    <VideoFrame
      src={embedUrl}
      title={title}
      loading="lazy"
      allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
      allowFullScreen
      data-testid="video-iframe"
    />
  </VideoWrapper>
);

export default YoutubePlayer;
